import RelatedCaseStudies from './RelatedCaseStudies';

export default RelatedCaseStudies;



// WEBPACK FOOTER //
// ./src/components/shared/RelatedCaseStudies/index.js